<template>
  <aside class="w-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-xl lg:rounded-2xl p-4 md:p-5 overflow-hidden">
    <PanelMenu
      :model="menuData"
      class="w-full custom-panel-menu"
      :multiple="true"
      v-model:expandedKeys="internalExpandedKeys"
    />
  </aside>
</template>

<script setup>
import PanelMenu from "primevue/panelmenu";
import { computed, ref, watch } from "vue";

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  expandedKeys: {
    type: Object,
    default: () => ({}),
  },
});

const internalExpandedKeys = ref({ ...props.expandedKeys });

watch(
  () => props.expandedKeys,
  (newValue) => {
    internalExpandedKeys.value = { ...(newValue || {}) };
  },
  { deep: true, immediate: true }
);

const menuData = computed(() => props.data || []);
</script>

<style scoped>
:deep(.p-panelmenu-panel) {
  border: none !important;
  background: transparent !important;
  margin-bottom: 0.25rem;
}

:deep(.p-panelmenu-header) {
  border: none !important;
  background: transparent !important;
}

:deep(.p-panelmenu-header-link),
:deep(.p-menuitem-link) {
  padding: 0.75rem 1rem !important;
  border-radius: 0.5rem !important;
  color: #6B7280 !important; /* text-gray-500 */
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
  border: none !important;
  background: transparent !important;
}

:deep(.p-panelmenu-header-link:hover),
:deep(.p-menuitem-link:hover) {
  background-color: #F9FAFB !important; /* bg-gray-50 */
  color: #111827 !important; /* text-gray-900 */
}

/* Active State Styles */
:deep(.panelmenu-item-active > .p-panelmenu-header .p-panelmenu-header-link),
:deep(.panelmenu-item-active > .p-menuitem-content > .p-menuitem-link) {
  background-color: #F3F4F6 !important; /* bg-gray-100 */
  color: #111827 !important;
  font-weight: 600 !important;
}

:deep(.p-menuitem-content) {
  border: none !important;
  background: transparent !important;
}

:deep(.p-panelmenu-content) {
  border: none !important;
  background: transparent !important;
  padding: 0.25rem 0 0 0.5rem !important;
}
</style>
